import { render, staticRenderFns } from "./VariablePrice.vue?vue&type=template&id=95d33102"
import script from "./VariablePrice.vue?vue&type=script&lang=js"
export * from "./VariablePrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports